import BaseModal from 'components/molecules/BaseModal';
import TreeView from 'components/atoms/TreeView';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext } from 'react';

const TreeModal = () => {
  const {
    treeModal: { isVisible },
    setTreeModal,
  } = useContext(GlobalContext);
  return (
    <BaseModal isVisible={isVisible} handleClose={() => setTreeModal({ isVisible: false, documents: [] })}>
      <h3>Documentos Relacionados</h3>
      <TreeView />
    </BaseModal>
  );
};

export default TreeModal;
